import { Checkbox } from "../../Checkbox/index.js";
import { Tooltip } from "../../Tooltip/index.js";
import React from "react";
import { IconLoader } from "@synthesis/shared-icons";
import { jsx } from "react/jsx-runtime";
import { useVirtualizer } from "@tanstack/react-virtual";
//#region src/TableListColumnFilter/local-components/CheckboxList.tsx
const CheckboxList = ({ getItemLabel, getItemTooltip, getItemId, items, selectedItems, onChange, onScrollEnd, hasNextPage, isFetching }) => {
	const parentRef = React.useRef(null);
	const scrollEndRef = React.useRef(onScrollEnd);
	scrollEndRef.current = onScrollEnd;
	const virtualizer = useVirtualizer({
		count: hasNextPage || isFetching ? items.length + 1 : items.length,
		getScrollElement: () => parentRef.current,
		estimateSize: () => 40,
		getItemKey: (index) => items[index]?.id ?? index,
		overscan: 2
	});
	const virtualItems = virtualizer.getVirtualItems();
	const lastVirtualItemIndex = virtualItems.at(-1)?.index;
	React.useEffect(() => {
		if (hasNextPage && !isFetching && lastVirtualItemIndex === items.length) scrollEndRef.current?.();
	}, [
		hasNextPage,
		isFetching,
		items.length,
		lastVirtualItemIndex
	]);
	return /* @__PURE__ */ jsx("div", {
		ref: parentRef,
		style: { maxHeight: `${Math.min(items.length || 5, 8) * 2.5}rem` },
		className: "[&::-webkit-scrollbar-thumb]:bg-neutrals-80 h-full min-h-0 w-full overflow-y-auto overflow-x-hidden [&::-webkit-scrollbar-thumb]:w-2 [&::-webkit-scrollbar-thumb]:rounded-[10px] [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar]:mr-2 [&::-webkit-scrollbar]:w-2",
		children: /* @__PURE__ */ jsx("ul", {
			className: "relative w-full",
			style: { height: `${virtualizer.getTotalSize()}px` },
			children: virtualItems.map((virtualItem) => {
				if (virtualItem.index === items.length) return /* @__PURE__ */ jsx(ScrollLoader, {
					index: virtualItem.index,
					start: virtualItem.start
				}, virtualItem.key);
				const item = items[virtualItem.index];
				if (!item) return null;
				const id = getItemId?.(item) ?? item.id ?? String(virtualItem.index);
				const label = getItemLabel?.(item) ?? item.label;
				const tooltip = getItemTooltip?.(item) ?? item.tooltip ?? label;
				const content = /* @__PURE__ */ jsx("div", {
					className: "h-10 overflow-y-hidden px-2.5 py-2",
					children: /* @__PURE__ */ jsx(Checkbox, {
						className: "w-full min-w-0",
						label: /* @__PURE__ */ jsx("span", {
							className: "block truncate",
							children: label ?? item.label
						}),
						checked: selectedItems[id] ?? false,
						onChange: () => onChange(id)
					})
				});
				const contentWrapped = /* @__PURE__ */ jsx(Tooltip, {
					description: tooltip,
					triggerEvent: "mouse",
					arrowSide: "left",
					children: content
				});
				return /* @__PURE__ */ jsx("li", {
					"data-index": virtualItem.index,
					className: "absolute left-0 top-0 w-full",
					style: { transform: `translateY(${virtualItem.start}px)` },
					children: contentWrapped
				}, virtualItem.key);
			})
		})
	});
};
const ScrollLoader = ({ index, start }) => /* @__PURE__ */ jsx("li", {
	"data-index": index,
	className: "absolute left-0 top-0 w-full",
	style: { transform: `translateY(${start}px)` },
	children: /* @__PURE__ */ jsx("div", {
		className: "flex h-10 cursor-progress items-center justify-center",
		children: /* @__PURE__ */ jsx(IconLoader, { className: "size-6 animate-spin" })
	})
});
//#endregion
export { CheckboxList };

//# sourceMappingURL=CheckboxList.js.map